import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import { AiOutlineFullscreen } from "react-icons/ai";
import { Link } from "react-router-dom";

const MyPdfViewer = ({ pdfFile, id }) => {
  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;

  return (
    <div style={{ height: "auto" }}>
      <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js`}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div>
            <Toolbar>
              {(props) => {
                const { ZoomIn, ZoomOut, Rotate } = props;

                return (
                  <div style={{ display: "flex" }}>
                    <ZoomOut />
                    <ZoomIn />
                    <Rotate direction="Backward" />
                    <Rotate direction="Forward" />
                    <Link
                      to={`/viewcertificate/${id}`}
                      target="_blank"
                      style={{
                        alignContent: "center",
                      }}
                    >
                      <div>
                        <AiOutlineFullscreen />
                      </div>
                    </Link>
                  </div>
                );
              }}
            </Toolbar>
          </div>
          <Viewer fileUrl={pdfFile} plugins={[toolbarPluginInstance]} />
        </div>
      </Worker>
    </div>
  );
};

export default MyPdfViewer;
